import TableList from "@components/templates/tablelist";
import {
    HttpGetDetailCilentZengzhiList,
    HttpGetbillPeriodList,
} from "@/service/newbigaccount";
import { HttpGetCusWareList } from "@/service/billing";
import { mapState, mapGetters } from "vuex";
import comExcel from './excelalert'

import mixin from "../../minxin";

export default {
    mixins: [TableList, mixin],
    components: {
        comExcel
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            formData: {
                search: {},
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            peroList: [],
            wareList: [],
        };
    },
    created() {
        HttpGetbillPeriodList({
            page: 1,
            rows: 10000,
        }).then((res) => {
            this.peroList = res.data.content;
        });
        // HttpGetCusWareList(this.getBeforeOrgList[0].value).then((res) => {
        //     this.wareList = res.data.map((item) => ({
        //         value: item.id,
        //         label: `${item.code}(${item.title})`,
        //         attach: {
        //             title: item.title,
        //             code: item.code,
        //             warehouseType: item.warehouseType,
        //             active: item.active,
        //         },
        //     }));
        // });
    },
    methods: {
        interceptRequest(params) {
            const { BT_periodDate, EQ_billStatus } = params.search;
            params.periodDate = BT_periodDate;
            params.billStatus = EQ_billStatus;

            delete params.search.BT_periodDate;
            delete params.search.EQ_billStatus;
            this.formData = params;
            return params;
        },
        ajaxRequest: HttpGetDetailCilentZengzhiList,

        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(",")) + "";
                if (!params.length)
                    return this.$VMessage.warning("请选择至少一条数据");
            }
            switch (type) {
                case "export":
                    this.export();
                    break;
            }
        },
        export(){
            const { search }=this.formData
                const startAt = search.BT_createdAt ? search.BT_createdAt.slice(0,10) : `''`;
                const endAt = search.BT_createdAt ? search.BT_createdAt.slice(13) : `''`;
                const complete_start_at = search.BT_completeDate ? search.BT_completeDate.slice(0,10) : `''`;
                const complete_end_at = search.BT_completeDate ? search.BT_completeDate.slice(13) : `''`;
                const searchItem = {
                    type: 0,
                    isManage: 0,
                    context_id: global.SYSID,
                    organization_id: search.EQ_organizationId || `''`,
                    bill_no: search.EQ_billNo || `''`,
                    bill_period_id: search.EQ_billPeriodId || `''`,
                    work_order_no: search.EQ_workOrderNo || `''`,
                    org_warehouse_id: search.EQ_orgWarehouseId || `''` ,
                    line_id: search.EQ_lineId || `''`,
                    billing_category_name_level: search.CN_billingCategoryNameLevel || `''`,
                    sku: search.CN_sku || `''`,
                    trade_no: search.EQ_tradeNo || `''`,
                    source_no: search.EQ_sourceNo || `''`,
                    expense_category_customize_code: search.CN_expenseCategoryCustomizeCode || `''`,
                    start_at: startAt,
                    end_at: endAt,
                    complete_start_at: complete_start_at || `''`,
                    complete_end_at: complete_end_at || `''`,
                    bill_status: search.EQ_billStatus || `''`,
                }
                this.handleWebfs(
                    process.env.VUE_APP_APIURL_BI + "/api/v1/ReportTask/save",
                    {args:JSON.stringify(searchItem), template_id: 10003},
                    {
                        executor: "request",
                        download: true,
                        method: "post",
                    }
                )
                .then((res) => {
                    this.operate = {
                      title: '查询条件导出',
                      show: true,
                      width: 560,
                      component: "comExcel",
                      fileId: res.data.id,
                      showFooter: false
                }})
                .catch((err) => {
                    // this.$VMessage.error(err.message);
                });
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [
                {
                    label: "删除",
                    show: true,
                    params: id,
                    operate: "delete",
                },
            ];
        },
    },
    computed: {
        ...mapGetters("dictionary", [
            "getBillcusorgList",
            "getCusproductList",
            "getCusBillTypeList",
            "getBeforeOrgList",
            'getFilterDisabledWarehouse'
        ]),
        ToolsData() {
            return [
                {
                    name: "导出",
                    operate: "export",
                    theme: "primary",
                },
            ];
        },
        SearchsData() {
            const dropStyle = "width:auto;";
            let widthStyle = 'width: 200px;'
            return [
                {
                    label: "账单编号",
                    tag: "vInput",
                    key: "EQ_billNo",
                    show: true,
                    style: widthStyle,
                },
                {
                    label: "仓库",
                    tag: "vSelect",
                    key: "EQ_orgWarehouseId",
                    // options: this.wareList,
                    options: this.getFilterDisabledWarehouse,
                    props: {
                        filterable: true,
                    },
                    show: true,
                    style: widthStyle,
                },
                // {
                //     label: '账期范围',
                //     tag: 'vDatepicker',
                //     key: 'BT_periodDate',
                //     style: "width:180px",
                //     props:{
                //         format:'yy-mm-dd',
                //         confirm:false,
                //     },
                //     show: true,
                // },
                {
                    label: "账期状态",
                    tag: "vSelect",
                    key: "EQ_billStatus",
                    options: [
                        { value: 0, label: "未关账" },
                        { value: 1, label: "已关账" },
                    ],
                    props: {
                        filterable: true,
                    },
                    style: widthStyle,
                    show: true,
                },
                {
                    label: "事物单号",
                    tag: "vInput",
                    key: "EQ_workOrderNo",
                    style: widthStyle,
                },
                {
                    label: "项目",
                    tag: "vSelect",
                    key: "EQ_lineId",
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle,
                },
                {
                    label: "结算日期",
                    tag: "vDatepicker",
                    key: "BT_completeDate",
                    props: {
                        options: this.options,
                        format: "yy-mm-dd ~ yy-mm-dd",
                        confirm: false,
                    },
                    style: widthStyle,
                },
                {
                    label: "创建日期",
                    tag: "vDatepicker",
                    key: "BT_createdAt",
                    props: {
                        options: this.options,
                        format: "yy-mm-dd ~ yy-mm-dd",
                        confirm: false,
                    },
                    style: widthStyle,
                },
            ];
        },
        columns() {
            return [
                {
                    title: "客户组织",
                    render: (h, { row }) => {
                        return <div>{row.organizationName}</div>;
                    },
                },
                {
                    title: "账单编号",
                    render: (h, { row }) => {
                        return <div>{row.billNo || "--"}</div>;
                    },
                },
                {
                    title: "账期范围",
                    render: (h, { row }) => {
                        return (
                            <div>
                                <div>
                                    {row.billStartTime || "--"} '~'{" "}
                                    {row.billEndTime || "--"}
                                </div>
                            </div>
                        );
                    },
                },
                {
                    title: "账期描述",
                    render: (h, { row }) => {
                        return <div>{row.billPeriodCode || "--"}</div>;
                    },
                },
                {
                    title: "账期状态",
                    render: (h, { row }) => {
                        return (
                            <div>
                                {row.billStatus == 0
                                    ? "未关账"
                                    : "已关账" || "--"}
                            </div>
                        );
                    },
                },
                {
                    title: "计费项",
                    render: (h, { row }) => {
                        return (
                            <div>{row.billingCategoryNameLevel || "--"}</div>
                        );
                    },
                },
                {
                    title: "计费金额",
                    render: (h, { row }) => {
                        return <div>{row.totalCost || "--"}</div>;
                    },
                },
                {
                    title: "币种",
                    render: (h, { row }) => {
                        return <div>{row.currency || "--"}</div>;
                    },
                },
                {
                    title: "事物单号",
                    render: (h, { row }) => {
                        return <div>{row.workOrderNo || "--"}</div>;
                    },
                },
                {
                    title: "仓库",
                    render: (h, { row }) =>
                        this.findRenderLabel(this.getFilterDisabledWarehouse, row.orgWarehouseId)||'--',
                },
                {
                    title: "项目",
                    render: (h, { row }) =>
                        this.findRenderLabel(
                            this.getCusproductList,
                            row.lineId
                        ) || "--",
                },
                {
                    title: '结算时间/创建时间',
                    width: 150,
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.completeDate || '--'}</div>
                            <div>{row.createdAt || '--'}</div>
                        </div>
                    }
                },
            ];
        },
    },
};
